import { __ } from '@wordpress/i18n';
import { InspectorControls, BlockControls, AlignmentToolbar } from '@wordpress/block-editor';
import { PanelBody, PanelRow, TextControl, ToggleControl, RangeControl, SelectControl, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl, Tooltip, Button, Dashicon } from '@wordpress/components';

// Settings Components
import { Label, Background, BColor, HelpPanel } from '../../../../../Components';
import { gearIcon } from '../../../../../Components/utils/icons';
import { pxUnit, perUnit, emUnit } from '../../../../../Components/utils/options';

import { types, pointStyles } from '../../../utils/options';

const Settings = ({ attributes, setAttributes }) => {
	const { data, type, background, textColor, isXScale, isXGridLine, isYScale, isYGridLine, gridLineColor, width, height, alignment, isTitle, title, titleFontSize, titleColor, isSubtitle, subtitle, subtitleFontSize, subtitleColor, isDownload } = attributes;

	const getRandomColor = () => {
		const letters = '0123456789abcdef';
		let color = '#';
		for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	}

	const updateData = (property, index, val, childProp = false, childI = false) => {
		const newData = { ...data }
		if (false !== childI && childProp) {
			newData[property][index][childProp][childI] = val;
		} else if (childProp) {
			newData[property][index][childProp] = val;
		} else {
			newData[property][index] = val;
		}
		setAttributes({ data: newData });
	}
	// const updateData = (property, index, val, childProp = false, childI = false) => {
	// 	const newData = produce(data, draft => {
	// 		if (childProp && false !== childI) {
	// 			draft[property][index][childProp][childI] = val;
	// 		} else if (childProp) {
	// 			draft[property][index][childProp] = val;
	// 		} else {
	// 			draft[property][index] = val;
	// 		}
	// 	});
	// 	setAttributes({ data: newData });
	// }

	const addDataset = () => {
		let newDatasets = [];
		for (let i = 0; i < data.datasets.length; i++) {
			newDatasets.push({
				label: data.datasets[i].label,
				data: [...data.datasets[i].data, Math.ceil(Math.random() * 20)],
				backgroundColor: [...data.datasets[i].backgroundColor, '#4527a433'],
				borderColor: [...data.datasets[i].borderColor, '#4527a4'],
				tension: data.datasets[i].tension,
				borderWidth: data.datasets[i].borderWidth,
				hoverBorderWidth: data.datasets[i].hoverBorderWidth,
				pointRadius: data.datasets[i].pointRadius,
				pointHoverRadius: data.datasets[i].pointHoverRadius,
				pointStyle: data.datasets[i].pointStyle
			})
		}

		setAttributes({
			data: {
				labels: [...data.labels, `Data ${data.labels.length + 1}`],
				datasets: [...newDatasets]
			}
		});
	}
	const removeDataset = (index) => {
		let newDatasets = [];
		for (let i = 0; i < data.datasets.length; i++) {
			newDatasets.push({
				label: data.datasets[i].label,
				data: [...data.datasets[i].data.slice(0, index), ...data.datasets[i].data.slice(index + 1)],
				backgroundColor: [...data.datasets[i].backgroundColor.slice(0, index), ...data.datasets[i].backgroundColor.slice(index + 1)],
				borderColor: [...data.datasets[i].borderColor.slice(0, index), ...data.datasets[i].borderColor.slice(index + 1)],
				tension: data.datasets[i].tension,
				borderWidth: data.datasets[i].borderWidth,
				hoverBorderWidth: data.datasets[i].hoverBorderWidth,
				pointRadius: data.datasets[i].pointRadius,
				pointHoverRadius: data.datasets[i].pointHoverRadius,
				pointStyle: data.datasets[i].pointStyle
			})
		}

		setAttributes({
			data: {
				labels: [...data.labels.slice(0, index), ...data.labels.slice(index + 1)],
				datasets: [...newDatasets]
			}
		});
	}

	const addDatasetValue = () => {
		let newData = [];
		let newBackgroundColor = [];
		let newBorderColor = [];
		for (let i = 0; i < data.labels.length; i++) {
			const newRandomColor = getRandomColor();

			newData.push(Math.ceil(Math.random() * 20));
			newBackgroundColor.push(`${newRandomColor}33`);
			newBorderColor.push(newRandomColor);
		}

		setAttributes({
			data: {
				labels: [...data.labels],
				datasets: [...data.datasets, {
					label: `Dataset Value ${data.datasets.length + 1}`,
					data: newData,
					backgroundColor: newBackgroundColor,
					borderColor: newBorderColor,
					tension: 0.4,
					borderWidth: 2,
					hoverBorderWidth: 2,
					pointRadius: 3,
					pointHoverRadius: 4,
					pointStyle: 'rectRounded'
				}]
			}
		});
	}

	const removeDatasetValue = (index) => {
		setAttributes({
			data: {
				labels: [...data.labels],
				datasets: [...data.datasets.slice(0, index), ...data.datasets.slice(index + 1)]
			}
		});
	}

	const duplicateDatasetValue = (index) => {
		setAttributes({
			data: {
				labels: [...data.labels],
				datasets: [...data.datasets, { ...data.datasets[index] }]
			}
		});
	}

	return <>
		<InspectorControls>
			<div className='bChartInspectorInfo'>
				Need more block like this? Checkout the bundle ➡ <a href='https://wordpress.org/plugins/b-blocks' target='_blank' rel='noopener noreferrer'>B Blocks</a>
			</div>

			<HelpPanel slug='chart-block' docsLink='https://bblockswp.com/docs/chart-block' />


			<PanelBody className='bPlPanelBody addRemoveDatasets' title={__('Add or Remove Datasets', 'chart-block')}>
				{data.labels.map((label, labelIndex) => <PanelRow key={labelIndex}>
					<Label className=''>{__(`Label ${labelIndex + 1}:`, 'chart-block')}</Label>
					<TextControl value={label} onChange={val => updateData('labels', labelIndex, val)} />

					<Tooltip text={__('Remove this Dataset', 'chart-block')} placement='top' position='top'>
						<Button className='removeDataset' onClick={e => {
							e.preventDefault();
							removeDataset(labelIndex);
						}} ><Dashicon icon='no' /></Button>
					</Tooltip>
				</PanelRow>)}

				<div className='addItem mt10 mb10'>
					<Button label={__('Add New Dataset', 'chart-block')} onClick={addDataset} ><Dashicon icon='plus' />{__('Add New Dataset', 'chart-block')}</Button>
				</div>

				{data.datasets.map((dataset, datasetIndex) => <PanelBody key={datasetIndex} className='bPlPanelBody editItem' title={__(`Dataset Value ${datasetIndex + 1}:`, 'chart-block')} initialOpen={0 !== datasetIndex ? false : true}>
					<PanelRow>
						<Label className=''>{__('Label:', 'chart-block')}</Label>
						<TextControl value={dataset.label} onChange={val => updateData('datasets', datasetIndex, val, 'label')} />
					</PanelRow>

					{data.labels.map((label, labelIndex) => <PanelRow key={labelIndex} className='bChartDatasetEdit'>
						<Label className=''>{__(`${label}:`, 'chart-block')}</Label>

						<NumberControl className='chartDataValue' value={dataset.data[labelIndex]} onChange={val => updateData('datasets', datasetIndex, parseFloat(val), 'data', labelIndex)} />

						<Tooltip text={__('Dataset Background Color', 'chart-block')} placement='top' position='top'>
							<BColor className='chartBGColor' label='' value={dataset.backgroundColor[labelIndex]} onChange={val => updateData('datasets', datasetIndex, val, 'backgroundColor', labelIndex)} />
						</Tooltip>

						<Tooltip text={__('Dataset Border Color', 'chart-block')} placement='top' position='top'>
							<BColor label='' value={dataset.borderColor[labelIndex]} onChange={val => updateData('datasets', datasetIndex, val, 'borderColor', labelIndex)} />
						</Tooltip>
					</PanelRow>)}

					<NumberControl className='mt20' label={__('Border Width:')} labelPosition='left' value={dataset.borderWidth} onChange={val => {
						// const newData = produce(data, draft => {
						// 	draft['datasets'][datasetIndex]['borderWidth'] = parseFloat(val);
						// 	draft['datasets'][datasetIndex]['hoverBorderWidth'] = parseFloat(val);
						// });
						const newData = { ...data }
						newData['datasets'][datasetIndex]['borderWidth'] = parseFloat(val);
						newData['datasets'][datasetIndex]['hoverBorderWidth'] = parseFloat(val);
						setAttributes({ data: newData });
					}} />

					<NumberControl className='mt15' label={__('Point Size:')} labelPosition='left' value={dataset.pointRadius} onChange={val => updateData('datasets', datasetIndex, parseFloat(val), 'pointRadius')} />

					<NumberControl className='mt15' label={__('Point Hover Size:')} labelPosition='left' value={dataset.pointHoverRadius} onChange={val => updateData('datasets', datasetIndex, parseFloat(val), 'pointHoverRadius')} />

					<PanelRow className='mt10'>
						<Label className=''>{__('Point Style:', 'chart-block')}</Label>
						<SelectControl value={dataset.pointStyle} onChange={val => updateData('datasets', datasetIndex, val, 'pointStyle')} options={pointStyles} />
					</PanelRow>

					<PanelRow className='itemAction'>
						<Button className='removeItem' label={__('Remove', 'chart-block')} onClick={e => {
							e.preventDefault();
							removeDatasetValue(datasetIndex);
						}} ><Dashicon icon='no' />{__('Remove', 'chart-block')}</Button>

						<Button className='duplicateItem' label={__('Duplicate', 'chart-block')} onClick={e => {
							e.preventDefault();
							duplicateDatasetValue(datasetIndex);
						}} >{gearIcon}{__('Duplicate', 'chart-block')}</Button>
					</PanelRow>
				</PanelBody>)}

				<div className='addItem'>
					<Button label={__('Add Dataset Value', 'chart-block')} onClick={addDatasetValue} ><Dashicon icon='plus' />{__('Add Dataset Value', 'chart-block')}</Button>
				</div>
			</PanelBody>


			<PanelBody className='bPlPanelBody' title={__('Chart Settings', 'chart-block')} initialOpen={false}>
				<PanelRow>
					<Label className=''>{__('Type:', 'chart-block')}</Label>
					<SelectControl value={type} onChange={val => setAttributes({ type: val })} options={types} />
				</PanelRow>
				<small>{__(`Use single dataset value for 'Pie', 'Doughnut', and 'Polar Area'`, 'chart-block')}</small>

				<UnitControl className='mt20' label={__('Width:', 'chart-block')} labelPosition='left' value={width} onChange={val => setAttributes({ width: val })} units={[pxUnit(), perUnit(), emUnit()]} />

				<UnitControl className='mt20' label={__('Height:', 'chart-block')} labelPosition='left' value={height} onChange={val => setAttributes({ height: val })} units={[pxUnit(), perUnit(), emUnit()]} />

				<Background className='mt20' label={__('Background:', 'chart-block')} value={background} onChange={val => setAttributes({ background: val })} defaults={{ color: '#0000' }} />

				<BColor label={__('Text Color:', 'chart-block')} value={textColor} onChange={val => setAttributes({ textColor: val })} defaultColor='#666' />

				<ToggleControl className='mt20' label={__('Show X Scale', 'chart-block')} checked={isXScale} onChange={val => setAttributes({ isXScale: val })} />

				{isXScale && <ToggleControl label={__('Show X Grid Line', 'chart-block')} checked={isXGridLine} onChange={val => setAttributes({ isXGridLine: val })} />}

				<ToggleControl className='mt20' label={__('Show Y Scale', 'chart-block')} checked={isYScale} onChange={val => setAttributes({ isYScale: val })} />

				{isYScale && <ToggleControl label={__('Show Y Grid Line', 'chart-block')} checked={isYGridLine} onChange={val => setAttributes({ isYGridLine: val })} />}

				{(isXGridLine || isYGridLine) && <BColor label={__('Grid Line Color:', 'chart-block')} value={gridLineColor} onChange={val => setAttributes({ gridLineColor: val })} defaultColor='#0000001a' />}
			</PanelBody>


			<PanelBody className='bPlPanelBody' title={__('Title & Subtitle Settings', 'chart-block')} initialOpen={false}>
				<ToggleControl label={__('Show Title', 'chart-block')} checked={isTitle} onChange={val => setAttributes({ isTitle: val })} />
				{isTitle && <>
					<PanelRow>
						<Label className=''>{__('Title:', 'chart-block')}</Label>
						<TextControl value={title} onChange={val => setAttributes({ title: val })} />
					</PanelRow>

					<Label>{__('Title Font Size:', 'chart-block')}</Label>
					<RangeControl value={titleFontSize} onChange={val => setAttributes({ titleFontSize: val })} min={0} max={80} step={1} allowReset={true} resetFallbackValue={22} initialPosition={22} />

					<BColor label={__('Title Color:', 'chart-block')} value={titleColor} onChange={val => setAttributes({ titleColor: val })} defaultColor='#4527a4' />
				</>}

				<ToggleControl className='mt20' label={__('Show Subtitle', 'chart-block')} checked={isSubtitle} onChange={val => setAttributes({ isSubtitle: val })} />
				{isSubtitle && <>
					<PanelRow>
						<Label className=''>{__('Subtitle:', 'chart-block')}</Label>
						<TextControl value={subtitle} onChange={val => setAttributes({ subtitle: val })} />
					</PanelRow>

					<Label>{__('Subtitle Font Size:', 'chart-block')}</Label>
					<RangeControl value={subtitleFontSize} onChange={val => setAttributes({ subtitleFontSize: val })} min={0} max={80} step={1} allowReset={true} resetFallbackValue={13} initialPosition={13} />

					<BColor label={__('Subtitle Color:', 'chart-block')} value={subtitleColor} onChange={val => setAttributes({ subtitleColor: val })} defaultColor='#8344c5' />
				</>}
			</PanelBody>


			<PanelBody className='bPlPanelBody' title={__('Download Settings', 'chart-block')} initialOpen={false}>
				<ToggleControl label={__('Download Button', 'chart-block')} checked={isDownload} onChange={val => setAttributes({ isDownload: val })} />
			</PanelBody>
		</InspectorControls>


		<BlockControls>
			<AlignmentToolbar value={alignment} onChange={val => setAttributes({ alignment: val })} describedBy={__('Chart Alignment')} alignmentControls={[
				{ title: __('Chart in left', 'chart-block'), align: 'left', icon: 'align-left' },
				{ title: __('Chart in center', 'chart-block'), align: 'center', icon: 'align-center' },
				{ title: __('Chart in right', 'chart-block'), align: 'right', icon: 'align-right' }
			]} />
		</BlockControls>
	</>;
};
export default Settings;